export const defaultState = {
  artifacts: {
    custom: false,
    days: null,
    builds: null,
    pattern: '',
    default: null,
    error: null,
  },
  history: {
    custom: false,
    days: null,
    builds: null,
    default: null,
    error: null,
  },
  everything: {
    custom: false,
    days: null,
    builds: null,
    default: null,
    error: null,
  },
  dependencies: 'default',
} as const
export const ERROR_MESSAGES = {
  not_specified: 'Neither the number of days nor the count of builds is specified',
  not_positive:
    'The number of days or count of builds should be a positive integer value or be empty.',
}
export const actions = {
  SET_CUSTOM: 'SET_CUSTOM',
  SET_DEPENDENCIES: 'SET_DEPENDENCIES',
  SET_VALUE: 'SET_VALUE',
  SET_ARTIFACTS_VALUE: 'SET_ARTIFACTS_VALUE',
  SET_ERROR: 'SET_ERROR',
} as const
